import React from "react";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import * as actions from "../../stores/actionsList"
// const GanttList = ({ tasks, hoveredId }) => {
const Month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]
class GanttList extends React.Component {

    render() {
        return (
            <div className="gantt-list" style={{ position: "sticky" }}>

                <div className="gantt-list-header">
                    {/* <div style={{ height: '20px', borderBottom: 'solid 1px #EBEDF1', display: "flex", flexDirection: "row", justifyContent: "center", padding: "0rem .5rem" }}>
                        <button className="prev-month"
                            onClick={() => this.props.prevMonth()}
                        >
                            Last
                        </button>
                        <button className="next-month"
                            onClick={() => this.props.nextMonth()}
                        >
                            Next
                        </button></div> */}
                    <div className="gantt-header flexcc " style={{ paddingLeft: "2rem" }}>
                        Tasks Name
                        <img src="/assets/icons/gantt/plus.svg" alt="" width="10" height="10" style={{ opacity: '50%' }} />

                    </div>

                </div>

                <div className="list-items-holder" id="list-items-holde">
                    <div className="list-items-header">
                        {this.props.inbox.desk.map((task) => {
                            const { taskName, id } = task;
                            return (
                                <div

                                    key={id}
                                    id={'task-' + id}
                                    className="list-item flexcc pld-1"
                                    style={{
                                        justifyContent: 'left',
                                        backgroundColor: this.props.hoveredId == id ? 'aliceblue' : '',
                                        border: this.props.hoveredId == id ? "dashed 0.1px rgb(90 66 243 / 33%)" : ""

                                    }}
                                >
                                    <span className="status"></span>
                                    <span className="list-item-text"
                                        style={{}}
                                    >{task.title}</span>

                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GanttList);
